import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { LocalClientDto } from '../../dtos/local-client.dto';

// No `Password`: a tutor account is always created through the invitation flow, which the backend
// selects by the absence of that field.
export interface CreateMobileClientPayload {
  readonly Username: string;
  readonly FirstName: string;
  readonly LastName: string;
  readonly RoleId: number | null;
  readonly DepartmentIds: readonly number[];
  readonly LinkedProviderClientExternalId: string;
  readonly CreateInProvider: boolean;
  // Lets the backend attach an EXISTING tutor account (email already registered at another clinic)
  // to this clinic through `LinkedProviderClientExternalId` instead of refusing the duplicate email.
  readonly LinkExistingAccount: boolean;
}

export interface UpdateMobileClientPayload {
  readonly Username: string;
  readonly FirstName: string;
  readonly LastName: string;
  readonly RoleId: number | null;
  readonly DepartmentIds: readonly number[];
  readonly IsActive: boolean;
  readonly LinkedProviderClientExternalId: string | null;
}

@Injectable()
export class MobileUsersRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public list(organizationId: number): Observable<readonly LocalClientDto[]> {
    return this.http.get<readonly LocalClientDto[]>(`${this.apiUrl}${API_ENDPOINTS.organizationClients.list(organizationId)}`, {
      params: { accountRealm: 'pet_owner' },
    });
  }

  public create(organizationId: number, payload: CreateMobileClientPayload): Observable<LocalClientDto> {
    return this.http.post<LocalClientDto>(`${this.apiUrl}${API_ENDPOINTS.organizationClients.list(organizationId)}`, { ...payload, AccountRealm: 'pet_owner', RoleId: null });
  }

  public update(organizationId: number, clientId: number, payload: UpdateMobileClientPayload): Observable<LocalClientDto> {
    return this.http.put<LocalClientDto>(
      `${this.apiUrl}${API_ENDPOINTS.organizationClients.byId(organizationId, clientId)}`, payload,
    );
  }

  public deactivate(organizationId: number, clientId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}${API_ENDPOINTS.organizationClients.byId(organizationId, clientId)}`);
  }

  public resendInvitation(organizationId: number, clientId: number): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}${API_ENDPOINTS.organizationClients.resendInvitation(organizationId, clientId)}`,
      null,
    );
  }
}
